export default {
      id: "edit_access-usage",
      viewBox: "0 0 24 17",
      url: __webpack_public_path__ + "img/icons.svg#edit_access",
      toString: function () {
        return this.url;
      }
    }